import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProfileComponent } from './profile.component';
import { RouterModule, Routes } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDividerModule } from '@angular/material/divider';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { PhotoUploadComponent } from './photo-upload/photo-upload.component';
import { SharedModule } from '../../../shared/shared.module';

const ANGULAR_MATERIAL_MODULES = [
  MatButtonModule, MatFormFieldModule, MatInputModule,
  MatDividerModule, MatIconModule
];

const CORE_MODULES = [CommonModule, FormsModule];

const COMPONENTS = [ProfileComponent, PhotoUploadComponent];

export const profile_nav_path = {};

const routes: Routes = [
  { path: '', component: ProfileComponent, pathMatch: 'full' }
];

@NgModule({
  declarations: [...COMPONENTS],
  imports: [
    RouterModule.forChild(routes), ...CORE_MODULES, ...ANGULAR_MATERIAL_MODULES,
    SharedModule
  ],
  exports: [RouterModule]
})
export class ProfileModule { }
